import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderService } from 'src/app/services/common/header.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('adsCategory') private adsCategory!: ElementRef;
  @ViewChild('productArea') private productArea!: ElementRef;

  public currentElement = 0;
  constructor(
    private _headerService: HeaderService,
    private meta: Meta,
    private title: Title,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  // TODO: Add an proper interface and move this to some kind of file or load it from backend
  private metaData = {
    title: 'Myescort.dk - Danskernes yndlings escort side',
    description:
      'Danskernes yndlings escort side. Find escort piger eller massage i nærheden af dig. Se alle escort og sex annoncer på vores side.',
  };

  ngOnInit(): void {
    // Set meta tags
    this.meta.updateTag({ name: 'title', content: this.metaData.title });
    this.meta.updateTag({
      name: 'description',
      content: this.metaData.description,
    });
    this.meta.updateTag({ property: 'og:title', content: this.metaData.title });
    this.meta.updateTag({
      property: 'og:description',
      content: this.metaData.description,
    });
    this.title.setTitle(this.metaData.title);

    /**
     * Get behavior subject data.
     */
    this._headerService.headerColorChange.next(false);
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) this.initIntersectionObserver();
  }

  private initIntersectionObserver() {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.8, // Trigger when 80% of the element is visible
    };

    const observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      options
    );

    const elementsToObserve = [
      this.adsCategory?.nativeElement,
      this.productArea?.nativeElement,
    ];
    // observing multiple elements
    elementsToObserve.forEach((el: Element) => {
      if (el) observer.observe(el);
    });
  }

  private handleIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
      if (
        entry.isIntersecting &&
        Number(entry.target.id) > this.currentElement
      ) {
        setTimeout(() => this.initIntersectionObserver(), 0); // used timeout to wait for the observer to observe untill the component is loaded.
        this.currentElement = Number(entry.target.id);
      }
    });
  }

  ngOnDestroy(): void {
    this._headerService.headerColorChange.next(true);
  }
}
